<template>
  <div class="pageLoading">
    <span />
    <span />
    <span />
    <div class="font">LOADING...</div>
  </div>
</template>
<script>
export default {
  name: 'PageLoading'
}
</script>
<style lang="scss" scoped>
.pageLoading {
  top: 42%;
  left: 0;
  right: 0;
  position: absolute;
  text-align: center;
  span {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 12px;
    margin-right: 8px;
    background: #1fa0e8;
    animation: load 0.9s linear infinite;
    &:nth-child(1) {
      -webkit-animation-delay: 0.2s;
    }
    &:nth-child(2) {
      -webkit-animation-delay: 0.3s;
    }
    &:nth-child(3) {
      -webkit-animation-delay: 0.4s;
    }
  }
  .font {
    font-size: 14px;
    color: #999;
    margin-top: 30px;
  }
  @keyframes load {
    33% {
      transform: translateY(5px);
    }
    66% {
      transform: translateY(-10px);
    }
    100% {
      transform: translateY(0);
    }
  }
}
</style>
